import api from './api';

// ── Practitioner-side ─────────────────────────────────────────────────────────

export const getThreads = (params) =>
  api.get('/api/v1/messages/threads', { params }).then((r) => r.data.data);

export const createThread = (data) =>
  api.post('/api/v1/messages/threads', data).then((r) => r.data.data);

export const getThread = (id) =>
  api.get(`/api/v1/messages/threads/${id}`).then((r) => r.data.data);

export const replyToThread = async (id, content, file) => {
  if (file) {
    const fd = new FormData();
    if (content) fd.append('content', content);
    fd.append('file', file);
    return api.post(`/api/v1/messages/threads/${id}/reply`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data.data);
  }
  return api.post(`/api/v1/messages/threads/${id}/reply`, { content }).then((r) => r.data.data);
};

export const archiveThread = (id, archived = true) =>
  api.patch(`/api/v1/messages/threads/${id}/archive`, { archived }).then((r) => r.data.data);

export const getAttachmentUrl = (threadId, messageId, idx) =>
  `/api/v1/messages/threads/${threadId}/messages/${messageId}/attachment/${idx}`;

// ── Portal (client-side) ──────────────────────────────────────────────────────

export const portalGetThreads = () =>
  api.get('/api/v1/portal/messages/threads').then((r) => r.data.data);

export const portalGetThread = (id) =>
  api.get(`/api/v1/portal/messages/threads/${id}`).then((r) => r.data.data);

export const portalReply = async (id, content, file) => {
  if (file) {
    const fd = new FormData();
    if (content) fd.append('content', content);
    fd.append('file', file);
    return api.post(`/api/v1/portal/messages/threads/${id}/reply`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data.data);
  }
  return api.post(`/api/v1/portal/messages/threads/${id}/reply`, { content }).then((r) => r.data.data);
};

export const portalGetAttachmentUrl = (threadId, messageId, idx) =>
  `/api/v1/portal/messages/threads/${threadId}/messages/${messageId}/attachment/${idx}`;
